import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { chores, users } from '../data/mockData';

const Chores = () => {
  const [taskList, setTaskList] = useState(chores);
  const [filter, setFilter] = useState('all');

  const toggleChore = (id) => {
    setTaskList(prev => prev.map(c => c.id === id ? { ...c, completed: !c.completed } : c));
  };

  const filteredTasks = taskList.filter(c => filter === 'all' ? true : c.assignee === filter);

  return (
    <div className="p-6 h-full flex flex-col pb-24 md:pb-6">
      <header className="mb-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Task Protocol</h1>
          <p className="text-sm text-slate-400">Manage household operations</p>
        </div>
        <div className="flex space-x-2 bg-slate-800 p-1 rounded-lg border border-slate-700">
          <button onClick={() => setFilter('all')} className={`px-4 py-1.5 rounded-md text-sm transition-all ${filter === 'all' ? 'bg-teal-500/20 text-teal-400 border border-teal-500/30' : 'text-slate-400 hover:text-slate-200'}`}>All</button>
          {users.map(u => (
            <button key={u.id} onClick={() => setFilter(u.id)} className={`px-4 py-1.5 rounded-md text-sm transition-all ${filter === u.id ? 'bg-teal-500/20 text-teal-400 border border-teal-500/30' : 'text-slate-400 hover:text-slate-200'}`}>
              {u.name}
            </button>
          ))}
        </div>
      </header>

      <div className="flex-1 overflow-y-auto space-y-3 scrollbar-hide pr-2">
        <AnimatePresence>
          {filteredTasks.map(chore => {
            const user = users.find(u => u.id === chore.assignee);
            return (
              <motion.div key={chore.id} layout initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }}
                className={`glass-panel p-4 rounded-xl flex items-center gap-4 transition-all duration-300 ${chore.completed ? 'opacity-50 border-slate-800' : 'hover:border-teal-500/30'}`}>
                
                <button onClick={() => toggleChore(chore.id)} className={`w-6 h-6 rounded flex items-center justify-center border-2 transition-colors ${chore.completed ? 'bg-teal-500 border-teal-500' : 'border-slate-500 hover:border-teal-400'}`}>
                  {chore.completed && <SafeIcon icon="FiCheck" className="text-slate-900 w-4 h-4" />}
                </button>
                
                <div className="flex-1 min-w-0">
                  <p className={`font-medium truncate ${chore.completed ? 'line-through text-slate-500' : 'text-slate-200'}`}>{chore.title}</p>
                  <p className="text-xs text-slate-400 mt-0.5 flex items-center gap-2">
                    <span><SafeIcon icon="FiMapPin" className="inline w-3 h-3 mr-1" />{chore.room}</span>
                    <span><SafeIcon icon="FiClock" className="inline w-3 h-3 mr-1" />{chore.due}</span>
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  {chore.priority === 'high' && !chore.completed && <span className="px-2 py-0.5 rounded text-[10px] uppercase font-bold bg-amber-500/20 text-amber-400 border border-amber-500/30">Priority</span>}
                  <img src={user?.avatar} alt={user?.name} className="w-8 h-8 rounded-full border border-slate-600 grayscale hover:grayscale-0 transition-all" />
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
        
        {filteredTasks.length === 0 && (
          <div className="flex flex-col items-center justify-center h-40 text-slate-500">
             <SafeIcon icon="FiCheckCircle" className="w-12 h-12 mb-3 opacity-20" />
             <p>All protocols complete.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chores;